<template>
  <div class="past-events card">
    <div v-for="(event, index) in eventArray" :key="index">
      <event-preview
        :event-data="event"
        :is-active="false"
      />
      <el-divider v-if="index < eventArray.length - 1" />
    </div>

    <div class="active-events__empty-message" v-if="eventArray.length === 0">
      There are no past events
    </div>
  </div>
</template>

<script>
import { getUserPastEvents } from '@/api/events.js';
import EventPreview from '@/components/events/EventPreview.vue';

export default {
  name: 'ActiveEvents',
  components: {
    EventPreview,
  },
  data() {
    return {
      eventArray: [],
    };
  },

  methods: {
    async fetchPastEvents() {
      const { data, success } = await getUserPastEvents();

      if (success) {
        this.eventArray = data.items;
      }
    },
  },
  created() {
    this.fetchPastEvents();
  },
};
</script>

<style lang="scss">
.active-events {
  &__empty-message {
    font-size: var(--font-size-300);
  }
}
</style>
